import { getSearchDatesFromFlightIdentifier } from './flightIdentifier';

export const getPackageLink = (identifier: any, customNavigationPath?: string) => {
    if (customNavigationPath) {
        return customNavigationPath.replace('{id}', identifier);
    } else {
        return '/package/' + identifier;
    }
};

// TODO: later replace "getPackageLink" usage with "packageLink"

export const packageLink = (singlePackage: any) => {
  return `/package/${singlePackage.identifier ?? singlePackage.id} `;
};

export const flightLink = (
  type: string,
  identifier: string,
  currentSearchParams: string
) => {
  return `/flight/view/${type}/${identifier}${currentSearchParams}`;
};

export const hotelLink = (identifier: string, currentSearchParams: string) => {
  return `/hotel/${identifier}${currentSearchParams}`;
};

export const attractionLink = (
  identifier: string,
  currentSearchParams: string
) => {
  return `/attractions/${identifier}${currentSearchParams}`;
};

export const eventLink = (
  identifier: string,
  currentSearchParams: string
) => {
  return `/events/${identifier}${currentSearchParams}`;
};

const DP_LINK_SEARCH_PARAM_KEYS = [
  'from',
  'to',
  'adult',
  'child',
  'infant',
  'destinationCity',
  'departure',
  'destination',
  'extId',
  'boardBasis',
  'hotelStar',
  'multi_room_guests',
  'directFlight',
] as const;

const applySearchParamsToUrl = (
  target: URLSearchParams,
  searchParams?: Record<string, unknown>
) => {
  if (!searchParams) {
    return;
  }
  const filteredParams = Object.fromEntries(
    Object.entries(searchParams).filter(
      ([, value]) => value !== null && value !== undefined && value !== ''
    )
  );

  for (const [key, value] of Object.entries(filteredParams)) {
    if (!DP_LINK_SEARCH_PARAM_KEYS.includes(key as (typeof DP_LINK_SEARCH_PARAM_KEYS)[number])) {
      continue;
    }
    if (Array.isArray(value) || typeof value === 'object') {
      target.set(key, JSON.stringify(value));
    } else {
      target.set(key, String(value));
    }
  }
};

export const dynamicPackageLink = ({
  h_id,
  f_id,
  searchParams,
}: {
  h_id: string;
  f_id?: string;
  /** Active search context (e.g. Redux); overrides stale from/to on window.location. */
  searchParams?: Record<string, unknown>;
}) => {
  const currentSearchParams = new URLSearchParams(window.location.search);
  applySearchParamsToUrl(currentSearchParams, searchParams);
  if (!currentSearchParams.get('from') || !currentSearchParams.get('to')) {
    const flightDates = getSearchDatesFromFlightIdentifier(f_id);
    if (!currentSearchParams.get('from') && flightDates.from) {
      currentSearchParams.set('from', flightDates.from);
    }
    if (!currentSearchParams.get('to') && flightDates.to) {
      currentSearchParams.set('to', flightDates.to);
    }
  }
  currentSearchParams.set('h', h_id);
  if (f_id) {
    currentSearchParams.set('f', f_id);
  }
  return `/dynamicPackage?${currentSearchParams.toString()}`;
};

export const dynamicPackageEventsLink = ({
  h_id,
  f_id,
  eTicket,
  searchParams,
}: {
  h_id: string;
  f_id?: string;
  eTicket?: string;
  searchParams?: Record<string, unknown>;
}) => {
  const currentSearchParams = new URLSearchParams(window.location.search);
  applySearchParamsToUrl(currentSearchParams, searchParams);
  if (!currentSearchParams.get('from') || !currentSearchParams.get('to')) {
    const flightDates = getSearchDatesFromFlightIdentifier(f_id);
    if (!currentSearchParams.get('from') && flightDates.from) {
      currentSearchParams.set('from', flightDates.from);
    }
    if (!currentSearchParams.get('to') && flightDates.to) {
      currentSearchParams.set('to', flightDates.to);
    }
  }
  currentSearchParams.set('h', h_id);
  if (f_id) {
    currentSearchParams.set('f', f_id);
  }
  if (eTicket) {
    currentSearchParams.set('eTicket', eTicket);
  }
  return `/dynamicPackageEvents?${currentSearchParams.toString()}`;
};